import React from 'react';
import { registerClass, currySC, IFNTheme } from '@food/css-manager';

interface IMagazineSpinnerProps {}

const styleClass = registerClass(
	(t: IFNTheme) => `
// AP Misure indicative (l'elemento deve essere inserito nello slider)
width: 13vw;
padding: 0 1vw;

.${sc('cover-placehold')} {
  // uso l'aspect ratio delle cover standard (8:10)
  padding-bottom: 124.3%;
  position: relative;
  background-color: ${t.colors.grey.disabled.light};
  align-items: center;
  
  .${sc('spinner')} {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
  
    > div {
      margin: 0 ${(t.ratios.xs / 4) * t.font.baseSize}px;
      width: ${(t.ratios.xs / 4) * 3 * t.font.baseSize}px;
      height: ${(t.ratios.xs / 4) * 3 * t.font.baseSize}px;
      background-color: ${t.colors.grey.disabled.plain};
      border-radius: 100%;
      display: inline-block;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }
    
    .${sc('bounce1')} {
      animation-delay: -0.32s;
    }
    
    .${sc('bounce2')} {
      animation-delay: -0.16s;
    }
    
    @keyframes sk-bouncedelay {
      0%, 80%, 100% {
        transform: scale(0);
      } 40% {
        transform: scale(1.0);
      }
    }
  }
}

.${sc('text-placehold-1')} {
  height: ${t.ratios.xs * t.font.baseSize}px;
  width: 75%;
  background-color: ${t.colors.grey.disabled.light};
  margin: ${(t.ratios.xs / 2) * t.font.baseSize}px auto;
}

.${sc('text-placehold-2')} {
  height: ${t.ratios.xs * t.font.baseSize}px;
  width: 40%;
  background-color: ${t.colors.grey.disabled.light};
  margin: ${(t.ratios.xs / 2) * t.font.baseSize}px auto;
}
  `,
);

const sc = currySC(styleClass);

const MagazineSpinner: React.FunctionComponent<IMagazineSpinnerProps> = () => (
	<div className={styleClass}>
		<div className={sc('cover-placehold')}>
			<div className={sc('spinner')}>
				<div className={sc('bounce1')} />
				<div className={sc('bounce2')} />
				<div className={sc('bounce3')} />
			</div>
		</div>
		<div className={sc('text-placehold-1')} />
		<div className={sc('text-placehold-2')} />
	</div>
);

export { MagazineSpinner };
